// Display-only status label. The DB continues to store "Closed" (old and new
// data); we only relabel it in the UI to "Reply Submitted". All other statuses
// are shown as-is. Use this everywhere a status is rendered to the user
// (tables, cards, dropdown option text, reports, graphs, map) — never for
// filtering, comparisons, or values sent to the backend.
export const statusLabel = (status) => {
  if (status === 'Closed') return 'Reply Submitted';
  return status;
};

export const formatDcfText = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  return value
    .replace(/\bDCFOs\b/g, 'DCFs')
    .replace(/\bDCFO\b/g, 'DCF')
    .replace(/\bDFOs\b/g, 'DCFs')
    .replace(/\bDFO\b/g, 'DCF');
};
